import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
} from "reactstrap";
import privateActions from "../../../../API/privateCalls/privateActions";

class ModalSponsor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      logoInfo:{data:''},
      loading:true
    };

    this.toggle = this.toggle.bind(this);
  }
getLogo=()=>{
    privateActions.getLogo(this.props.sponsor.id).then(res=>{
        console.warn(res)
        this.setState({logoInfo:res,loading:false})
    })
}
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
    this.getLogo()
  }

  render() {
   
    return (
      <span className="d-inline-block mb-2 mr-2">
        <Button color="primary" onClick={this.toggle}>
          Ver Detalles
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
            {this.state.loading?null:(
<div>

           
          <ModalHeader toggle={this.toggle}>
            {this.props.sponsor.nombre}
          </ModalHeader>
          <ModalBody></ModalBody>
          <Row className="d-flex justify-content-center">
            <Col md="10 ">
              <Card className="main-card mb-3">
                <CardBody>
                  <Form>
                    <FormGroup>
                      <Label for="exampleEmail">Nombre</Label>
                      <Input
                        value={this.props.sponsor.nombre}
                        type="email"
                        name="email"
                        disabled
                        id="exampleEmail"
                        placeholder="with a placeholder"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="example">descripción</Label>
                      <Input
                        value={this.props.sponsor.descripcion}
                        type=""
                        disabled
                        name="localidad"
                        id="localidad"
                        placeholder="No tiene descripcion"
                      />
                    </FormGroup>
                    <FormGroup>
                      <img
                        className="rounded-image m-0  center "
                        width={"100%"}
                        src={"data:image/jpeg;base64,"+this.state.logoInfo.data}
              
                      />
                    </FormGroup>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ModalFooter>
            <Button color="primary" onClick={this.toggle}>
              Volver
            </Button>{" "}
          </ModalFooter>
          </div>
           )}
        </Modal>
      </span>
    );
  }
}

export default ModalSponsor;



// WEBPACK FOOTER //
// src/Pages/Sponsor/SponsorC/component/modalSponsor.js